export default {
  SERVER_URL: 'https://whats-app-e-commerce.vercel.app',
};
